import { Component } from "react"
import PropTypes from "prop-types"
import parse from "html-react-parser"

import SortableWrapper from "shared/components/sortable_wrapper"
import bookIcon from "images/partners/book.svg?raw"
import editIcon from "images/partners/edit.svg?raw"

import { reorderTqasMutation } from "../../utils/reorder_tqas"

class QueryList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      queries: this.props.queries,
    }
  }

  handleNewClick = event => {
    event.preventDefault()
    this.props.updateRouter("new")
  }

  handleEditClick = query => {
    return event => {
      event.preventDefault()
      this.props.updateRouter("edit", query)
    }
  }

  handleOrderChange = newQueries => {
    const oldQueries = this.state.queries
    newQueries.forEach((q, index) => (q.weight = index))
    this.setState({ queries: newQueries })
    const sortedQueriesIds = newQueries.map(q => q.id)

    reorderTqasMutation(this.props.service.slug, "query", sortedQueriesIds)
      .then(() => {
        this.props.updateQueries("replace_all", newQueries)
        window.appendFlash("Queries reordered")
      })
      .catch(() => {
        this.setState({ queries: oldQueries })
        window.appendFlash("There has been an error reordering the Queries, try again!", "error")
      })
  }

  render() {
    return (
      <>
        <header className="page-header with-actions">
          <h1>Queries</h1>

          <div className="header-actions">
            <a
              onClick={this.handleNewClick}
              className="button-tertiary"
              href={`${this.props.queriesUrl}/new`}
            >
              New query
            </a>
          </div>
        </header>

        {this.state.queries.length == 0 ? (
          <EmptyList referenceUrl={`${this.props.referenceUrl}#queries`} />
        ) : (
          <section className="input-list form-section">
            <SortableWrapper
              signature={this.state.queries.map(i => i.id).join(":")}
              items={this.state.queries}
              onOrderUpdate={this.handleOrderChange}
            >
              <ul className="draggable-list">
                {this.state.queries.map(query => (
                  <li key={query.id}>
                    {query.name}
                    <span className="links">
                      <a
                        title="Edit query"
                        onClick={this.handleEditClick(query)}
                        href={`${this.props.queriesUrl}/${query.module_name}`}
                      >
                        <span className="svg-edit-icon">{parse(editIcon)}</span>
                      </a>
                    </span>
                  </li>
                ))}
              </ul>
            </SortableWrapper>
          </section>
        )}
      </>
    )
  }
}

const EmptyList = ({ referenceUrl }) => (
  <div className="zero-case">
    <div className="zero-case-items">
      <div className="zero-case-item">
        <a href={referenceUrl} target="_blank" rel="noreferrer">
          <span>{parse(bookIcon)}</span>
          <span>Learn how to create your first Query</span>
        </a>
      </div>
    </div>
  </div>
)

QueryList.propTypes = {
  service: PropTypes.object.isRequired,
  queries: PropTypes.array.isRequired,
  referenceUrl: PropTypes.string.isRequired,
  queriesUrl: PropTypes.string.isRequired,
  updateRouter: PropTypes.func.isRequired,
  updateQueries: PropTypes.func.isRequired,
}

export default QueryList
